module.exports = __webpack_public_path__ + "img/rosepetal-aisvisionrev.0ac502e2.jpg";